<template>
    <div class="footer_box" :style="{height: typefaces == 1 ? '120px' : '140px'}">
        <div class="footer">
            <p v-for="(item, index) in typefaces == 1 ? dataText : dataEnglishText" :key="index" @click="jump(item.router)">{{item.name}}</p>
        </div>
        <p style="border-top:1px solid #E7E7E7;padding:10px 0;text-align: center;color: #8E8D8D;font-size: 12px;">© 2015-2022子拓国际有限公司</p>
    </div>
</template>

<script>

export default {
	name: 'Footer',
    props: {
        typeFaces:{
            type: Number,
            default(){
                return '0';
            }
        }
    },
	data () {
		return {
			dataText: [
                {name: '网站首页', router: '/'},
                {name: '公司简介', router: '/companyProfile'},
                {name: '公司新闻', router: '/CompanyNews'},
                {name: '项目介绍', router: '/CoalTrade'},
                {name: '业务范围', router: '/Ganqimaodu'},
                {name: '行业资讯', router: '/Industry'},
                {name: '联系我们', router: '/ContactUs'}
            ],
            dataEnglishText: [
                {name: 'Home', router: '/'},
                {name: 'Corporate Introduction', router: '/companyProfile'},
                {name: 'Corporate News', router: '/CompanyNews'},
                {name: 'Project Introduction', router: '/CoalTrade'},
                {name: 'Business', router: '/Ganqimaodu'},
                {name: 'Industry News', router: '/Industry'},
                {name: 'Contact Us', router: '/ContactUs'}
            ],
            typefaces: 1
		}
	},

    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch:{
        aaa(type) {
            this.typefaces = type;
        },
        typeFaces:function(){
            this.getinit();
            this.jump();
        }
    },

    mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.jump();
    },

    methods: {
        getinit(){
            this.typefaces = this.typeFaces;
        },

        jump(router) {
            this.$router.push(router);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

p {
    padding: 0;
    margin: 0;
}
.footer_box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    z-index: 999;
    height: 120px;
}
.footer {
    display: flex;
    flex-wrap: wrap;
    background: #FFFFFF;
}
.footer p {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    color:#8E8D8D;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue